import {
  LayoutDashboard,
  FolderKanban,
  PlusCircle,
  LogOut,
  Users,
  History,
  Building2,
  KeyRound,
  PanelLeftClose,
  PanelLeftOpen,
  Workflow,
  CreditCard,
  Megaphone,
  Moon,
  Sun
  ,Headphones
} from "lucide-react";

import logo from "../Logo.png";

function Sidebar({
  activeTab,
  setActiveTab,
  canEdit,
  isAdmin,
  canAssignCompanies,
  canMonitorBackups = false,
  canManageParasut = false,
  onLogout,
  setShowNewProjectModal,
  user,
  userData,
  userRole,
  moduleSettings,
  isCollapsed = false,
  toggleSidebar,
  themeMode = "light",
  toggleThemeMode,
  processProjects = [],
  selectedProcessProjectId,
  openProcessProject
}) {
  const menuItemStyle = (tabName) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: isCollapsed ? "center" : "flex-start",
    gap: isCollapsed ? 0 : 9,
    padding: isCollapsed ? "10px 8px" : "10px 12px",
    borderRadius: 12,
    marginBottom: 6,
    cursor: "pointer",
    background: activeTab === tabName ? "rgba(255,255,255,0.14)" : "transparent",
    color: "#fff",
    fontWeight: 700,
    fontSize: 13,
    border: "none",
    width: "100%",
    boxSizing: "border-box",
    transition: "all .2s ease"
  });

  const menuText = (text) => !isCollapsed && (
    <span
      style={{
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        lineHeight: 1.1
      }}
      title={text}
    >
      {text}
    </span>
  );
  const hasProcessProjectAccess = moduleSettings?.monthlyProcesses !== false;
  const processProjectList =
    processProjects.length > 0
      ? processProjects
      : [{ id: "monthly-processes", name: "Aylık Süreçler" }];

  return (

<div
        style={{
          width: isCollapsed ? 76 : 180,
          minWidth: isCollapsed ? 76 : 180,
          height: "100vh",
          position: "sticky",
          top: 0,
          background: "linear-gradient(180deg, #124254 0%, #0f3442 100%)",
          color: "#fff",
          padding: "14px 14px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "4px 0 20px rgba(0,0,0,0.08)",
          overflowY: "auto",
          transition: "width .2s ease, min-width .2s ease"
        }}
>

<div style={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
    
    <div style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: isCollapsed ? "center" : "space-between",
        gap: 8, 
        marginBottom: isCollapsed ? 16 : 18
        }}
    >
          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
            <img
              src={logo}
              alt="e-cAlp Logo"
              style={{
                width: isCollapsed ? 34 : 40,
                height: isCollapsed ? 34 : 40,
                borderRadius: 12,
                background: "#fff",
                padding: 6,
                objectFit: "contain"
              }}
            />

            {!isCollapsed && <div>
              <div style={{ fontSize: 12, opacity: 0.7, lineHeight: 1.15 }}>Proje Yönetim Sistemi</div>
            </div>}
          </div>

          <button
            onClick={toggleSidebar}
            title={isCollapsed ? "Menüyü genişlet" : "Menüyü daralt"}
            style={{
              width: 30,
              height: 30,
              borderRadius: 9,
              border: "1px solid rgba(255,255,255,0.12)",
              background: "rgba(255,255,255,0.08)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              flex: "0 0 30px"
            }}
          >
            {isCollapsed ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
          </button>
          </div>

          {!isCollapsed && <button
            type="button"
            onClick={() => setActiveTab("profile")}
            title="Profilimi aç"
            style={{
              width: "100%",
              textAlign: "left",
              padding: "10px 12px",
              marginBottom: 12,
              background: "linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.06))",
              border: "1px solid rgba(255,255,255,0.14)",
              borderRadius: 14,
              color: "#fff",
              cursor: "pointer",
              position: "relative",
              boxSizing: "border-box",
              boxShadow: "inset 0 1px 0 rgba(255,255,255,0.10)"
            }}
          >
            <span
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                width: 20,
                height: 20,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.10)",
                fontSize: 12,
                opacity: 0.8
              }}
            >
              ⚙️
            </span>

            <div style={{ display: "flex", alignItems: "center", gap: 9, paddingRight: 18 }}>
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.16)",
                  border: "2px solid rgba(255,255,255,0.28)",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  fontSize: 15,
                  fontWeight: 900
                }}
              >
                {(userData?.photoURL || user?.photoURL) ? (
                  <img
                    src={userData?.photoURL || user?.photoURL}
                    alt="Kullanıcı avatarı"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover"
                    }}
                  />
                ) : (
                  (userData?.name || user?.email || "?").slice(0, 1).toLocaleUpperCase("tr-TR")
                )}
              </div>

              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 900,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    letterSpacing: "-0.01em"
                  }}
                >
                  {userData?.name || user?.email}
                </div>

                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginTop: 4,
                    padding: "2px 7px",
                    borderRadius: 999,
                    background: "rgba(255,255,255,0.10)",
                    fontSize: 10,
                    fontWeight: 800,
                    opacity: 0.82
                  }}
                >
                  {userRole === "admin"
                    ? "Admin"
                    : userRole === "editor"
                    ? "Düzenleyici"
                    : "Görüntüleyici"}
                </div>
              </div>
            </div>
          </button>}

          <div title="Dashboard" onClick={() => setActiveTab("dashboard")} style={menuItemStyle("dashboard")}>
            <LayoutDashboard size={18} />
            {menuText("Dashboard")}
          </div>

          <button
            title="Duyurular"
            onClick={() => setActiveTab("announcements")}
            style={menuItemStyle("announcements")}
          >
            <Megaphone size={18} />
            {menuText("Duyurular")}
          </button>

          {canEdit && (
            <button
              title="Destek Merkezi"
              onClick={() => setActiveTab("support")}
              style={menuItemStyle("support")}
            >
              <Headphones size={18} />
              {menuText("Destek Merkezi")}
            </button>
          )}

          {hasProcessProjectAccess && (
            <button
              title="Süreç Projeleri"
              onClick={() => openProcessProject?.(selectedProcessProjectId || processProjectList[0]?.id)}
              style={activeTab === "mailTasks" ? menuItemStyle("mailTasks") : menuItemStyle("monthlyProcesses")}
            >
              <Workflow size={18} />
              {menuText("Süreç Projeleri")}
            </button>
          )}

          <button
            title="Muafiyetli Gün Raporu"
            onClick={() => setActiveTab("exemptionDayReport")}
            style={menuItemStyle("exemptionDayReport")}
          >
            <span style={{ fontSize: 15 }}>📊</span>
            {menuText("Muafiyetli Gün Raporu")}
          </button>

          {canEdit && (
            <div title="Yeni Proje" onClick={() => setShowNewProjectModal(true)} style={menuItemStyle("")}>
              <PlusCircle size={18} />
              {menuText("Yeni Proje")}
            </div>
            )}

          <div title="Tüm Projeler" onClick={() => setActiveTab("projects")} style={menuItemStyle("projects")}>
            <FolderKanban size={18} />
            {menuText("Tüm Projeler")}
          </div>

          <button
            title="Portal Bilgileri"
            onClick={() => setActiveTab("portalCredentials")}
            style={menuItemStyle("portalCredentials")}
          >
            <KeyRound size={18} />
            {menuText("Portal Bilgileri")}
          </button>

          {canManageParasut && (
            <button
              title="Paraşüt Cari"
              onClick={() => setActiveTab("parasutIntegration")}
              style={menuItemStyle("parasutIntegration")}
            >
              <CreditCard size={18} />
              {menuText("Paraşüt Cari")}
            </button>
          )}

          <div title="Firmalar" onClick={() => setActiveTab("companies")} style={menuItemStyle("companies")}>
            <Users size={18} />
            {menuText("Firmalar")}
          </div>

          <div title="Müşteriler" onClick={() => setActiveTab("customers")} style={menuItemStyle("customers")}>
            <Building2 size={18} />
            {menuText("Müşteriler")}
          </div>

            {(isAdmin || canAssignCompanies) && (
            <div title="Kullanıcılar" onClick={() => setActiveTab("users")} style={menuItemStyle("users")}>
                <Users size={18} />
                {menuText("Kullanıcılar")}
            </div>
          )}

          <button
            title="Dosya Yönetimi"
            onClick={() => setActiveTab("files")}
            style={menuItemStyle("files")}
          >
            <span style={{ fontSize: 15 }}>📁</span>
            {menuText("Dosya Yönetimi")}
          </button>

          <div title="Arşiv" onClick={() => setActiveTab("archived")} style={menuItemStyle("archived")}>
            <History size={18} />
            {menuText("Arşiv")}
          </div>

          {isAdmin && (
            <div title="Sistem Hareketleri" onClick={() => setActiveTab("logs")} style={menuItemStyle("logs")}>
              <History size={18} />
              {menuText("Sistem Hareketleri")}
            </div>
          )}

          {canMonitorBackups && (
            <button title="Yedek Takibi" onClick={() => setActiveTab("backupStatus")} style={menuItemStyle("backupStatus")}>
              <span style={{ fontSize: 15 }}>🛡️</span>
              {menuText("Yedek Takibi")}
            </button>
          )}

          <button
            title={themeMode === "dark" ? "Açık temaya geç" : "Karanlık temaya geç"}
            onClick={toggleThemeMode}
            style={{
              ...menuItemStyle(""),
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.12)",
              marginTop: 3,
              flex: "0 0 auto"
            }}
          >
            {themeMode === "dark" ? <Sun size={18} /> : <Moon size={18} />}
            {menuText(themeMode === "dark" ? "Açık Tema" : "Karanlık Tema")}
          </button>

        <button
          title="Çıkış Yap"
          onClick={onLogout}
          style={{
            width: "100%",
            padding: isCollapsed ? "10px 8px" : "10px 12px",
            borderRadius: 12,
            border: "1px solid rgba(255,255,255,0.15)",
            background: "rgba(255,255,255,0.08)",
            color: "#fff",
            fontWeight: 800,
            fontSize: 13,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: isCollapsed ? 0 : 8,
            marginTop: "auto",
            flex: "0 0 auto"
          }}
        >
          <LogOut size={17} />
          {menuText("Çıkış Yap")}
        </button>
        </div>
      </div>
        );

}

export default Sidebar;
